import { motion } from "framer-motion";
import { Check, Sparkles } from "lucide-react";
import { PRICING, CONTACT } from "../lib/data";

export const Pricing = () => {
    const prefix = "//";
    return (
        <section id="pricing" data-testid="pricing-section" className="relative py-24 md:py-32">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="max-w-3xl mb-16">
                    <div className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-400 mb-4">
                        {prefix} Investment
                    </div>
                    <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter">
                        Simple, transparent pricing <span className="text-gradient-cyan">No hidden fees.</span>
                    </h2>
                    <p className="mt-6 text-lg text-slate-400 leading-relaxed">
                        Pick a package that fits today. Upgrade as you grow. Every project starts with a free
                        30-minute discovery call.
                    </p>
                </div>
            </div>
            <div className="max-w-8xl mx-auto px-6 md:px-10">
                <div className="grid md:grid-cols-4 gap-5">
                    {PRICING.map((p, i) => (
                        <motion.div
                            key={p.tier}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: i * 0.08 }}
                            data-testid={`pricing-tier-${p.tier.toLowerCase()}`}
                            className={`relative rounded-2xl p-8 border transition-all ${p.highlighted
                                ? "border-cyan-400/60 bg-gradient-to-b from-cyan-500/10 to-[#0a1024] glow-cyan"
                                : "border-white/15 bg-[#0a1024] hover:border-white/15"
                                }`}
                        >
                            {p.highlighted && (
                                <div className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-cyan-400 text-[#040814] text-[10px] font-bold uppercase tracking-[0.18em]">
                                    <Sparkles size={11} />
                                    Most picked
                                </div>
                            )}

                            <div className="text-sm uppercase tracking-[0.2em] font-bold text-slate-400 mb-3">
                                {p.tier}
                            </div>
                            <div className="flex items-baseline gap-2 mb-3">
                                <div className={`text-4xl font-black tracking-tighter ${p.highlighted ? "text-gradient-cyan" : "text-white"}`}>
                                    {p.price}
                                </div>
                                <span className="text-slate-500 text-sm">{p.sub}</span>
                            </div>
                            <p className="text-slate-400 text-[15px] leading-relaxed mb-7">{p.desc}</p>

                            <a
                                data-testid={`pricing-cta-${p.tier.toLowerCase()}`}
                                href={`https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(
                                    `Hi RS Digital Web Studio, I'm interested in the ${p.tier} package.`
                                )}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`block text-center w-full py-3.5 rounded-full font-semibold transition-all mb-7 ${p.highlighted
                                    ? "bg-cyan-400 text-[#040814] hover:bg-cyan-300 hover:shadow-lg hover:shadow-cyan-500/30"
                                    : "border border-cyan-400/50 text-white hover:border-cyan-400/50 hover:bg-cyan-300 hover:text-[#040814]"
                                    }`}
                            >
                                Choose {p.tier}
                            </a>

                            <ul className="space-y-3">
                                {p.features.map((f) => (
                                    <li key={f} className="flex items-start gap-3 text-[15px] text-slate-300">
                                        <Check size={16} className="text-cyan-400 mt-1 shrink-0" />
                                        <span>{f}</span>
                                    </li>
                                ))}
                            </ul>
                        </motion.div>
                    ))}
                </div>
            </div>
            <div>
                <p className="text-center mt-12 text-sm text-slate-500">
                    Domain & hosting costs not included — approx. £10–30/mo depending on provider. I can assist with setup and recommend reliable, affordable options.
                </p>
            </div>
        </section>
    );
};
